/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringResources
 */
export interface StringResources {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringResources
     */
    values?: Array<string>;
}

/**
 * Check if a given object implements the StringResources interface.
 */
export function instanceOfStringResources(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StringResourcesFromJSON(json: any): StringResources {
    return StringResourcesFromJSONTyped(json, false);
}

export function StringResourcesFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringResources {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'values': !exists(json, 'values') ? undefined : json['values'],
    };
}

export function StringResourcesToJSON(value?: StringResources | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'values': value.values,
    };
}

